// LandingPageContext.tsx
import { PlaybackDetailsResponse } from 'queries/details/usePlaybackDetailsQuery';
import React, { createContext, useContext, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

interface MainProviderContextValue {
  response: PlaybackDetailsResponse;
  setResponse: React.Dispatch<React.SetStateAction<PlaybackDetailsResponse>>;
  shortUrl: string | undefined;
  isPreview: boolean;
  isBuilderPreviewMode: boolean;
  notifyFlag: string | null;
  triggerViewNotification: boolean;
}

const MainProviderContext = createContext<MainProviderContextValue | undefined>(
  undefined
);

export const useMainProviderContext = () => {
  const context = useContext(MainProviderContext);
  if (!context) {
    throw new Error('useMainPageContext must be used within a MainProvider');
  }
  return context;
};

const PREVIEW_QUERY_PARAM = 'preview';
export const MainProvider = ({
  children,
  value,
}: {
  children?: React.ReactNode;
  value: PlaybackDetailsResponse;
}) => {
  const { shortUrl } = useParams();
  const { search, pathname } = useLocation();

  const query = new URLSearchParams(search);

  const notifyFlag = query.get('nn');
  const isPreview = query.get(PREVIEW_QUERY_PARAM) !== null;
  const isBuilderPreviewMode = pathname.includes('/preview/');
  const triggerViewNotification = !isBuilderPreviewMode && notifyFlag != '1';

  // this should be removed in future and only react-query cache should be used
  const [response, setResponse] = useState<PlaybackDetailsResponse>(value);

  return (
    <MainProviderContext.Provider
      value={{
        response,
        setResponse,
        shortUrl,
        isPreview,
        isBuilderPreviewMode,
        notifyFlag,
        triggerViewNotification,
      }}
    >
      {children}
    </MainProviderContext.Provider>
  );
};
